module.exports = __webpack_public_path__ + "static/media/mmume_05.ce0920cc.png";